package com.eladfinish.bible.contest.navigation.back

import androidx.navigation.NavController
import androidx.navigation.NavDestination
import com.eladfinish.bible.contest.navigation.popBackStackSafely
import com.eladfinish.bible.contest.ui.common.LastBackPressState
import io.github.aakira.napier.Napier

internal fun handleBackClick(
    navController: NavController,
    dismissSnackbar: () -> Boolean,               // true if dismissed
    shouldUseDoubleBackToExit: () -> Boolean,     // root + REGULAR
    lastBackPressState: LastBackPressState,
    onConfirmExitToast: () -> Unit,
    exitApp: () -> Unit,
    onBackClick: (NavDestination?) -> Unit,
    onStartDestinationBackClick: () -> Unit,
    interceptBack: (() -> Boolean)? = null, // true = consumed
    source: String,
) {
    Napier.d("handleBackClick source - $source")

    // 1) First: dismiss snackbar if showing
    if (dismissSnackbar()) return

    // 2) Let current visible screen consume back
    if (interceptBack?.invoke() == true) return

    val currentEntry = navController.currentBackStackEntry
    val isAtStartDestination =
        currentEntry?.destination?.id == navController.graph.startDestinationId

    // 3) At root: double-back-to-exit (only in your allowed state)
    if (isAtStartDestination && shouldUseDoubleBackToExit()) {
        lastBackPressState.handle(
            onFirstPress = onConfirmExitToast,
            onSecondPress = exitApp,
        )
        return
    }

    // 4) Otherwise, your existing behavior
    if (isAtStartDestination) {
        onStartDestinationBackClick()
        return
    }

    val poppedDestination = navController.currentDestination
    val popped = navController.popBackStackSafely()
    if (popped) {
        onBackClick(poppedDestination)
    } else {
        onStartDestinationBackClick()
    }
}
